import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "hiddenInput"]

  toggle(event) {
    event.preventDefault()
    const panelId = event.currentTarget.dataset.panel

    this.panelTargets.forEach(panel => {
      if (panel.dataset.panel === panelId) {
        panel.classList.toggle("hidden")
      } else {
        panel.classList.add("hidden")
      }
    })
  }

  updateHiddenInput(event) {
    const filterType = event.target.dataset.filterType
    const checkboxes = this.element.querySelectorAll(`input[type="checkbox"][data-filter-type="${filterType}"]`)
    const values = Array.from(checkboxes).filter(cb => cb.checked).map(cb => cb.value)
    const hidden = this.hiddenInputTargets.find(el => el.dataset.filterType === filterType)

    if (values.length > 0) {
      hidden.name = filterType
      hidden.value = values.join("+")
    } else {
      hidden.removeAttribute("name")
    }
  }
}
